var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import * as TokenizationClientProvider from './TokenizationClientProvider';
export var TokenizationClientFrame = function (_a) {
    var onTokenReceived = _a.onTokenReceived, onErrorReceived = _a.onErrorReceived, onStateChangeReceived = _a.onStateChangeReceived, children = _a.children, iFrameDisabledMessage = _a.iFrameDisabledMessage, other = __rest(_a, ["onTokenReceived", "onErrorReceived", "onStateChangeReceived", "children", "iFrameDisabledMessage"]);
    var _b = TokenizationClientProvider.useTokenizationClient(), tokenServerUrl = _b.tokenServerUrl, pageReadyToRenderIFrame = _b.windowReady, portReady = _b.portReady, setOnTokenReceived = _b.setOnTokenReceived, setOnErrorReceived = _b.setOnErrorReceived, setOnStateChangeReceived = _b.setOnStateChangeReceived, developerMode = _b.developerMode;
    if (onTokenReceived) {
        setOnTokenReceived(onTokenReceived);
    }
    if (onErrorReceived) {
        setOnErrorReceived(onErrorReceived);
    }
    if (onStateChangeReceived) {
        setOnStateChangeReceived(onStateChangeReceived);
    }
    var url = new URL(tokenServerUrl);
    var urlParamList = [['host', document.location.origin]];
    if (developerMode) {
        urlParamList.push(['debug', 'true']);
    }
    url.search = new URLSearchParams(urlParamList).toString();
    // While the Provider configures itself, render whatever content the consumer wishes (or nothing)
    if (!pageReadyToRenderIFrame) {
        return React.createElement(React.Fragment, null, children);
    }
    else {
        return React.createElement(React.Fragment, null,
            React.createElement("iframe", __assign({ src: url.href }, other, { style: { border: 0, width: '100%', height: '100%' } }), iFrameDisabledMessage.toString()));
    }
};
//# sourceMappingURL=TokenizationClientFrame.js.map